import { useQuery } from 'react-query';
import { useService } from '@core/inversify-react';

import { GetShopTypesRepoType, IGetShopTypesRepo } from '../repos';
import { IShopType } from '../interfaces';

export const useShopTypes = () => {
  const getShopTypesRepo = useService<IGetShopTypesRepo>(GetShopTypesRepoType);

  return useQuery<IShopType[]>(
    'shop-types',
    async () => {
      const result = await getShopTypesRepo.execute({ page: 1, per_page: 10000 });

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    { staleTime: 1000 * 60 * 15 },
  );
};
